var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_29786)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7692 1.95348V23.1627C21.7692 23.473 21.5973 23.7577 21.3227 23.9027C21.0481 24.0478 20.7166 24.0289 20.4598 23.8536L17.6747 21.9526L15.0414 23.8425C14.7255 24.0702 14.2946 24.049 14.0021 23.7922L12.0018 22.0431L10.0014 23.7922C9.70894 24.049 9.27806 24.0702 8.96217 23.8425L6.32886 21.9526L3.54379 23.8536C3.28704 24.0288 2.95553 24.0478 2.68088 23.9027C2.40628 23.7576 2.23438 23.4729 2.23438 23.1627V1.95348C2.23442 0.875158 3.10844 0 4.1879 0H19.8157C20.8951 0 21.7692 0.875158 21.7692 1.95348ZM20.0948 1.95348C20.0948 1.79943 19.9698 1.67441 19.8157 1.67441H4.1879C4.03385 1.67441 3.90883 1.79943 3.90883 1.95348V21.5776L5.869 20.2392C6.15923 20.0405 6.54323 20.0449 6.829 20.2503L9.39866 22.0955L11.4504 20.3005C11.7663 20.0237 12.2374 20.0237 12.5532 20.3005L14.605 22.0955L17.1746 20.2503C17.4604 20.0449 17.8444 20.0405 18.1346 20.2392L20.0948 21.5776V1.95348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53642 6.13925C7.07429 6.13925 6.69922 5.76419 6.69922 5.30205C6.69922 4.83991 7.07429 4.46484 7.53642 4.46484H16.4666C16.9287 4.46484 17.3038 4.83991 17.3038 5.30205C17.3038 5.76419 16.9287 6.13925 16.4666 6.13925H7.53642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53642 10.6041C7.07429 10.6041 6.69922 10.229 6.69922 9.76689C6.69922 9.30476 7.07429 8.92969 7.53642 8.92969H16.4666C16.9287 8.92969 17.3038 9.30476 17.3038 9.76689C17.3038 10.229 16.9287 10.6041 16.4666 10.6041H7.53642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53642 15.0689C7.07429 15.0689 6.69922 14.6939 6.69922 14.2317C6.69922 13.7696 7.07429 13.3945 7.53642 13.3945H12.0015C12.4637 13.3945 12.8387 13.7696 12.8387 14.2317C12.8387 14.6939 12.4637 15.0689 12.0015 15.0689H7.53642Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_29786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderRequest);
export default __webpack_public_path__ + "static/media/OrderRequest.395123309d57b8989670f5b68c98fa4e.svg";
export { ForwardRef as ReactComponent };